<script lang="ts">
  import { type TeamApp } from "$stores/teams";

  import {
    Root as DropdownMenuRoot,
    Trigger as DropdownMenuTrigger,
    Content as DropdownMenuContent,
    Group as DropdownMenuGroup,
    Item as DropdownMenuItem,
  } from "$ui/dropdown-menu";
  import { Button } from "$ui/button";
  import { cn } from "$utils/ui";
  import {
    Root as DrawerRoot,
    Content as DrawerContent,
    Header as DrawerHeader,
    Title as DrawerTitle,
    Description as DrawerDescription,
  } from "$ui/drawer";
  import { LoadingSpinner } from "$ui/loading-spinner";

  import DotsIcon from "$assets/icons/dots.svelte";
  import AppShapesIcon from "$assets/icons/app-shapes.svelte";
  import AppApiKeys from "$lib/components/apps/AppApiKeys.svelte";
  import EditIcon from "$assets/icons/edit.svelte";
  import BinIcon from "$assets/icons/bin.svelte";
  import AppForm from "$lib/components/apps/AppForm.svelte";
  import AppDeleteDialog from "./AppDeleteDialog.svelte";

  export let app: TeamApp;
  export let canEdit: boolean = false;

  let editOpen = false;
  let deleteOpen = false;
</script>

<DrawerRoot bind:open={editOpen} preventScroll={false} closeFocus={null} onOpenChange={() => {}}>
  <DrawerContent>
    <DrawerHeader class="pt-8 px-6 pb-4 relative">
      <DrawerTitle class="text-xl text-left">Edit Application</DrawerTitle>
      <DrawerDescription class="p text-base text-left">Edit the details of the {app.id} application</DrawerDescription>
    </DrawerHeader>
    <div class="px-6 flex-1 flex flex-col overflow-auto">
      <AppForm {app} onComplete={() => (editOpen = false)} />
    </div>
  </DrawerContent>
</DrawerRoot>

<div class="card p-6 flex-1 flex flex-col gap-4">
  {#if !app}
    <div class="flex flex-col items-center gap-3 [&>svg]:w-6">
      <LoadingSpinner />
    </div>
  {:else}
    <div class="flex gap-3">
      <div class={cn("flex-1 grid grid-cols-[40px_1fr] items-center gap-y-2 gap-x-3")}>
        <div class="border border-general p-2 rounded-full">
          <AppShapesIcon />
        </div>
        <div class="flex flex-col">
          <h3 class="text-lg font-semibold flex-1 leading-snug">{app.id}</h3>
        </div>
        {#if app.description}
          <div class="col-span-2 line-clamp-2">
            <p title={app.description}>{app.description}</p>
          </div>
        {/if}
      </div>

      <DropdownMenuRoot>
        <DropdownMenuTrigger asChild let:builder>
          <Button variant="ghost" builders={[builder]} class="max-h-[32px] px-3">
            <DotsIcon />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent class="w-52" side="right" align="start">
          <DropdownMenuGroup>
            <DropdownMenuItem on:click={() => (editOpen = true)} Icon={EditIcon} disabled={!canEdit}
              >Edit</DropdownMenuItem
            >
            <DropdownMenuItem
              class="!text-danger-400"
              on:click={() => (deleteOpen = true)}
              Icon={BinIcon}
              disabled={!canEdit}
            >
              Delete
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenuRoot>
    </div>
    <div class="border-t border-general pt-3 flex flex-col gap-1">
      <div class="font-semibold">Redirect URLs</div>
      {#if (app.redirectUris?.length ?? 0 > 0) && app.redirectUris[0] !== ""}
        <p class="" data-testid="app-redirect-url">{app.redirectUris.join(", ")}</p>
      {:else}
        <p class="">-</p>
      {/if}
    </div>
    <AppApiKeys appId={app.id} />
  {/if}
</div>

<AppDeleteDialog appId={app.id} open={deleteOpen}></AppDeleteDialog>
